import {
  db,
  lookup,
  lookupList,
  bind,
  FB_VALUE,
  storage
} from "../firebase/index.js";
import * as flamelink from "../firebase/flamelink.js";
import * as types from "./mutation-types";
import router from "@/router";
import { MAX_SRS, SRS_BASE_INTERVAL, VERB_LESSON_MAP } from "@/constants.js";
import { generatePromptSet } from "@/verbprompts.js";
import firebase from "firebase";
import {
  getCode,
  SAMPLE_VERBS,
  VERB_FORMS,
  VERB_NUMBER,
  VERB_PERSON,
  VERB_QUESTION_TYPES,
  VERB_TENSES,
  QUESTION_TYPES,
  PRACTICE_ROUND_LENGTH
} from "../constants.js";
import { generateLessonVerbSet } from "../verbprompts.js";
import _, { get, join } from "lodash";

const actions = {
  async resetUser() {
    var user = firebase.auth().currentUser;
    var credential;

    // Prompt the user to re-provide their sign-in credentials

    user
      .reauthenticateWithCredential(credential)
      .then(function() {
        // User re-authenticated.
        console.log("Re-authentication successful!");
        user
          .delete()
          .then(function() {
            // User deleted.
            console.log("User deleted");
          })
          .catch(function(error) {
            // An error happened.
            console.log("Error occurred:", error);
          });
      })
      .catch(function(error) {
        // An error happened.
        console.log("Re-authentication error:", error);
      });
  },

  async lookupUser({ commit, dispatch }, payload) {
    let response;
    try {
      response = await db
        .ref("Users/" + payload.uid)
        .once("value")
        .then(snapshot => {
          if (snapshot.val()) {
            console.log("Find user in firebase db success");
            commit(types.SET_USER, snapshot.val());
          } else {
            console.log("No user in the db, creating new entry");
            dispatch("createUserData", payload);
          }
        })
        .catch(err => {
          console.log(err);
        });
    } catch (ex) {
      return;
    }
  },
  async createUserData({ commit, dispatch }, payload) {
    let response;
    await dispatch("lookupUser");
    var userData = {
      id: payload.uid,
      email: payload.email,
      name: payload.displayName,
      avatar: payload.photoURL,
      joinDate: payload.metadata.creationTime,
      currentLesson: 0,
      level: 1,
      lessonReviewed: false
    };
    response = await db
      .ref("Users")
      .child(payload.uid)
      .set(userData)
      .then(function() {
        console.log("Create new user data success");
        commit(types.SET_USER, userData);
      })
      .catch(err => {
        console.log(err + " User data creation");
        router.push("/Error");
        commit(types.SET_ERROR, true);
      });
  },
  finishLesson({ commit, dispatch, state }) {
    db.ref("Users")
      .child(state.user.id)
      .child("lessonReviewed")
      .transaction(
        function(reviewed) {
          reviewed = true;
          return reviewed;
        },
        function(error, committed, snapshot) {
          if (error) {
            console.log("Transaction failed abnormally!", error);
          } else if (!committed) {
            console.log("We aborted the transaction");
          } else {
            // console.log('lessonReviewed = true')
            commit("setLessonFinished");
          }
        }
      );
  },
  updateUserData({ commit }, payload) {
    db.ref("Users")
      .child(payload.id)
      .update(payload)
      .then(
        db
          .ref("Users")
          .child(payload.id)
          .once(FB_VALUE)
          .then(function(snapshot) {
            commit("setUser", snapshot.val());
          })
      )
      .catch(err => console.log(err));
  },

  //Content fetching
  async getAllLessons({ commit, dispatch }) {
    let response;
    await dispatch("lookupUser");
    response = await db
      .ref(flamelink.LESSONS_PATH)
      .orderByChild("title")
      .once(FB_VALUE)
      .then(function(snapshot) {
        var result = [];
        snapshot.forEach(function(childSnapshot) {
          result.push(childSnapshot.val());
        });
        commit(types.SET_LESSONS, result);
      })
      .catch(err => console.log(err));
  },
  async getVocab({ commit, dispatch }) {
    // await dispatch("getAllLessons");
    let response = await lookup(flamelink.WORDS_PATH, function(payload) {

      commit(types.SET_VOCAB, payload.map(obj => ({ ...obj, type: 'noun' })));
    });
  },
  async getFMQuestions({ commit, dispatch }) {
    let response = await lookup(flamelink.FMQUESTION_PATH, function(payload) {
      commit("setFMQuestions", payload);
    });
  },
  async getVerbQuestions({ commit, dispatch }) {
    let response = await lookup("VerbPrompts", function(payload) {
      commit("setVerbQuestions", payload);
    });
  },
  async getPaleoQuestions({ commit }) {
    let response = await lookup(flamelink.PALEO_PATH, function(payload) {
      commit("setPaleoQuestions", payload);
    });
  },
  async getPrimerData({ commit }) {
    let response = await lookup(flamelink.PRIMER_PATH, function(payload) {
      commit("setPrimerData", payload);
    });
  },
  async getPaleoImage({ commit ,state}, filename) {
    if(state.paleoImages.filter(x=> x.filename===filename).length > 0) return;
    var paleoImageRef = storage.child("flamelink/media");
    console.log(filename);
    paleoImageRef
      .child(filename)
      .getDownloadURL()
      .then(function(url) {
        // console.log(url)
        commit("addPaleoImage", { url: url, filename: filename });
      });
  },
  async getPaleoImageSet({dispatch},files){
    files.forEach((file) =>{
      dispatch("getPaleoImage",file.file)
    })
  },
  async getPrimerImage({ commit, state }, filename) {
    if (state.primerImages.find(i => i.name === filename)) return;
    var primerImageRef = storage.child("flamelink/media");
    console.log(filename);
    primerImageRef
      .child(filename)
      .getDownloadURL()
      .then(function(url) {
        // console.log(url)
        commit("setPrimerImages", { url: url, name: filename });
      });
  },
  async getPrimerImagesByPart({ commit }, imgList) {
    await lookupList(flamelink.MEDIA_PATH, function(payload) {
      commit("setImages", payload);
    });
  },
  async getImages({ commit }) {
    await lookup(flamelink.MEDIA_PATH, function(payload) {
      commit("setImages", payload);
    });
  },
  async getQueue({ commit, state, dispatch }) {
    let response = await bind("UserQueues/" + state.user.id, function(payload) {
      commit(types.SET_QUEUE, payload);
    });
  },
  async getQuestions({ commit, dispatch }) {
    await dispatch("getAllLessons");
    await dispatch("getVocab");
    await dispatch("getQueue");
    await dispatch("getPaleoData");
    await dispatch("getVerbQuestions");
    await dispatch("getFMQuestions");
  },
  async getPaleoData({ commit, dispatch }) {
    await dispatch("getPrimerData");
    await dispatch("getPaleoQuestions");
    await dispatch("getImages");
  },
  addToVocabQueue({ commit, state }, payload) {
    var def = { id: payload.id, srs: 1, lastChange: Date.now(), type: "vocab" };
    db.ref("UserQueues")
      .child(state.user.id)
      .child(payload.id)
      .set(def)
      .then(function() {
        console.log("Add word to user queue success");
        commit("enqueue", def);
      })
      .catch(err => console.log(err));
  },
  async getLessonQuestions({ commit, state, getters, dispatch }) {
    await dispatch("generateVerbQuestions");
    let response = await lookup(flamelink.FMQUESTION_PATH, function(payload) {
      var result = [];
      payload.forEach(function(question) {
        if (
          getters.currentLesson &&
          question.lesson === getters.currentLesson.id
        ) {
          result.push({
            id: question.id,
            srs: 1,
            lastChange: Date.now(),
            type: "fm"
          });
        }
      });

      result.forEach(function(q) {
        commit("enqueue", q);
        db.ref("UserQueues")
          .child(state.user.id)
          .child(q.id)
          .set(q);
      });
    });
  },
  updateVocabQueue({ commit, state, getters, dispatch }, tracker) {
    var update = {
      id: tracker.id,
      srs: tracker.srs + 1,
      lastChange: Date.now(),
      type: tracker.type
    };
    db.ref("UserQueues")
      .child(state.user.id)
      .child(update.id.toString())
      .transaction(
        function(word) {
          if (word) {
            if (word.srs < MAX_SRS) {
              word.srs = update.srs;
              word.lastChange = update.lastChange;
            }
          }
          return word;
        },
        function(error, committed, snapshot) {
          if (error) {
            console.log("Transaction failed abnormally!", error);
          } else if (!committed) {
            console.log("We aborted the transaction");
          } else {
            console.log("Transaction complete");
            commit("srsLevelUp", update);
            if (getters.willLevelUp) dispatch("levelUp");
          }
        }
      );
  },

  //User Level
  levelUp({ commit, state }) {
    db.ref("Users")
      .child(state.user.id)
      .child("currentLesson")
      .transaction(
        function(lesson) {
          if (lesson) {
            lesson++;
            commit("userLevelUp", lesson);
          }
          return lesson;
        },
        function(error, committed, snapshot) {
          if (error) {
            console.log("Transaction failed abnormally!", error);
          } else if (!committed) {
            console.log("We aborted the transaction");
          } else {
            console.log("Transaction complete");
          }
        }
      );
  },

  async ChangeLesson({ commit, dispatch }, [payload, lessonNum]) {
    let response;
    console.log("lesson num in actions =" + lessonNum);
    await dispatch("lookupUser");
    var userData = {
      id: payload.uid,
      email: payload.email,
      name: payload.displayName,
      avatar: payload.photoURL,
      joinDate: payload.metadata.creationTime,
      currentLesson: lessonNum,
      level: 1,
      lessonReviewed: false
    };
    response = await db
      .ref("Users")
      .child(payload.uid)
      .set(userData)
      .then(function() {
        console.log("Updated Lesson Number");
        commit(types.SET_USER, userData);
      })
      .catch(err => {
        console.log(err + " User lesson change");
        router.push("/Error");
        commit(types.SET_ERROR, true);
      });
  },

  async ResetQueue({ commit, dispatch }, payload) {
    let response;
    await dispatch("lookupUser");
    var def = { contents: null };
    db.ref("UserQueues")
      .child(payload.uid)
      .set(def)
      .then(function() {
        console.log("Queue cleared");
      })
      .catch(err => console.log(err));
  },

  async checkTense({ commit, state }) {
    var entry = VERB_LESSON_MAP.find(
      e => e.lesson === state.user.currentLesson
    );
    if (!entry) return;
    console.log("checktense:" + entry.tense);
    return entry.tense;
  },

  async generateVerbQuestions({ commit, state }) {
    //lookup map entry with lesson + level to get the matching tense and categories
    var entry = VERB_LESSON_MAP.find(
      e => e.lesson === state.user.currentLesson
    );
    if (!entry) return;
    var specs = {
      categories: entry.categories,
      tenses: entry.tense,
      forms: Object.values(VERB_FORMS),
      types: VERB_QUESTION_TYPES
    };
    //call genSet function to create a set of questions
    //need to ensure converage of ind + dep forms**
    var set = generateLessonVerbSet(specs);
    console.log(set);
    //add srs trackers to those questions
    set.forEach(verb => {
      //generate ID for the permutation
      var code = getCode(verb);
      var tracker = {
        srs: 1,
        lastChange: Date.now(),
        type: verb.type,
        id: code
      };
      db.ref("UserQueues")
        .child(state.user.id)
        .child(code)
        .set(tracker);
      delete verb.type;
      verb.id = code;
      db.ref("VerbPrompts")
        .child(code)
        .once(FB_VALUE)
        .then(function(snapshot) {
          if (!snapshot.val()) {
            db.ref("VerbPrompts")
              .child(code)
              .set(verb)
              .then(() => {
                console.log("Added verb prompt to verbprompts");
              })
              .catch(err => console.log(err));
          } else {
            console.log("existing entry: ");
            console.log(payload);
          }
        });
    });
  },

  async generatePaleoQuestions({ getters, state, commit ,dispatch}, args) {
    var level = args.level;
    var tempQuestions =
      level === "all"
        ? _.shuffle(state.paleoQuestions)
        : _.shuffle(state.paleoQuestions.filter(x => x.level === level));
    if(args.rolloverElements){
        var rolloverMatches = tempQuestions.filter(x => args.rolloverElements.map(y=>y.id).includes(x.id));
        console.log(rolloverMatches);
        _.pull(tempQuestions,rolloverMatches);
        tempQuestions = _.concat(rolloverMatches,tempQuestions);
        tempQuestions = _.uniq(tempQuestions);
        console.log(tempQuestions);
    }
    var results = [];
    for (var i = 0; i < tempQuestions.length; i++) {
        var q = tempQuestions[i];
      results.push({
        img: getters.image(q.image[0]),
        context: q.contextImage
          ? getters.image(q.contextImage[0])
          : null,
        answers: q.answerSet.map(x => x.answer),
        hint: q.hintText,
        displayAnswer: q.displayAnswer,
        level: q.level,
        type: "paleoquiz",
        id: q.id
      });
    }
    dispatch("getPaleoImageSet",results.map(x=>x.img))
    dispatch("getPaleoImageSet",results.filter(y=>y.context).map(x=>x.context))
    commit("setPracticeQueue", results);
  },
  async generatePracticeQuestions({ commit, dispatch }, arg) {
    var type = arg.type.toLowerCase();
    if (type == "verb") {
      var res = generatePromptSet(arg.params, PRACTICE_ROUND_LENGTH);
      commit("setPracticeQueue", res);
    } else if (type == "vocab") {
    } else if (type == "paleography") {
      dispatch("generatePaleoQuestions", arg);
    }
  }
};

export default actions;
